import {
	Component, OnInit, OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MonitorPolicy, MonitorSettings_PRTG } from 'DiscoveryEngine.TS/Monitors';
import { MonitorConfigComponentBase } from '../../MonitorConfigComponentBase';
import { ProtocolSettings, ProtocolSettingsTypes, PrtgSettings } from 'DiscoveryEngine.TS/Protocols';
import { NavigationService, NetFacadeService } from 'netview';
import { StringUtils } from 'DiscoveryEngine.TS/Utils/StringUtils';


@Component({
	selector: 'prtg-settings-2',
	templateUrl: './prtgsettings2.component.html',
	styleUrls: ['./prtgsettings2.component.scss']
})
export class PrtgSettings2Component extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	public name: UntypedFormControl;
	public enabled: UntypedFormControl;
	public prtgTarget: UntypedFormControl;
	public prtgUsername: UntypedFormControl;
	public prtgPasshash: UntypedFormControl;
	public prtgTargetGUID: UntypedFormControl;

	public prtgSettings: PrtgSettings[];

	constructor(private fb: UntypedFormBuilder,
		private netFacadeService: NetFacadeService,
		private navService: NavigationService,
	) {
		super();

		this.prtgSettings = [];
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let netViewGuid = this.navService.location.netViewGuid;
		let network = this.netFacadeService.findNetwork(netViewGuid);

		// Populate PRTG settings.
		this.prtgSettings = [];
		if (network) {
			let emptyPS = new PrtgSettings();
			emptyPS.Name = "";
			emptyPS.GUID = "";
			this.prtgSettings.push(emptyPS);

			network.ProtocolSettings.ForEach((ps: ProtocolSettings) => {
				if (ps.SettingsType == ProtocolSettingsTypes.Prtg) {
					this.prtgSettings.push(<PrtgSettings>ps);
				}
			}, this);
		}

		this.BuildForm();
	}

	public ngOnDestroy(): void {
		return;
	}

	public BuildForm(): void {
		let name = "";
		let enabled = false;
		let prtgTarget = "";
		let prtgUsername = "";
		let prtgPasshash = "";
		let prtgTargetGUID = "";

		if (!!this.editor && this.editor.HasPolicy) {
			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_PRTG = <MonitorSettings_PRTG>monPolicy.Settings;

			name = monPolicy.Name;
			enabled = monPolicy.Enabled;
			prtgTargetGUID = monSettings.PrtgTargetGUID;

			let protoSettings: PrtgSettings = this.findSettingsByGuid(prtgTargetGUID);
			prtgTarget = protoSettings ? protoSettings.ServerUrl : "";
			prtgUsername = protoSettings ? protoSettings.UserName : "";
			prtgPasshash = protoSettings ? StringUtils.ClarifyString2(protoSettings.Passhash) : "";
		}

		this.name = new UntypedFormControl(name, Validators.required);
		this.enabled = new UntypedFormControl(enabled);
		this.prtgTarget = new UntypedFormControl(prtgTarget, Validators.required);
		this.prtgTarget.disable();
		this.prtgUsername = new UntypedFormControl(prtgUsername, Validators.required);
		this.prtgUsername.disable();
		this.prtgPasshash = new UntypedFormControl(prtgPasshash, Validators.required);
		this.prtgPasshash.disable();
		this.prtgTargetGUID = new UntypedFormControl(prtgTargetGUID, Validators.required);

		this.SettingsForm = this.fb.group({
			name: this.name,
			enabled: this.enabled,
			prtgTarget: this.prtgTarget,
			prtgUsername: this.prtgUsername,
			prtgPasshash: this.prtgPasshash,
			prtgTargetGUID: this.prtgTargetGUID,
		});
	}

	public applyTempChanges(): void {
		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_PRTG = <MonitorSettings_PRTG>monPolicy.Settings;

			monPolicy.Name = this.name.value;
			monPolicy.Enabled = this.enabled.value;
			monSettings.PrtgTargetGUID = this.prtgTargetGUID.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Settings"];
	}

	private findSettingsByGuid(guid: string): PrtgSettings {
		guid = guid.toLowerCase();
		return this.prtgSettings.find(settings => settings.GUID.toLowerCase() === guid);
	}

	public onPrtgTargetChange(): void {
		const selectedSettingsGuid = this.prtgTargetGUID.value;
		const selectedSettings = (selectedSettingsGuid ? this.findSettingsByGuid(selectedSettingsGuid) : null);
		if (selectedSettings) {
			this.prtgTarget.setValue(selectedSettings.ServerUrl);
			this.prtgUsername.setValue(selectedSettings.UserName);
			this.prtgPasshash.setValue(StringUtils.ClarifyString2(selectedSettings.Passhash));
		}
		else {
			this.prtgTarget.setValue("");
			this.prtgUsername.setValue("");
			this.prtgPasshash.setValue("");
		}
	}

}
